import { createReducer } from '@reduxjs/toolkit';

import getLogs from '../../thunks/logs/getLogs';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
  lastPage: undefined,
  currentPage: 1
};

const getLogsReducer = createReducer(initialState, {
  [getLogs.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getLogs.fulfilled]: (state, { payload: { data, current_page: currentPage, last_page: lastPage } }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage
  }),
  [getLogs.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getLogsReducer;
